import { StaticPage } from './StaticPage'

const sections = [
  { id: 'overview', label: 'Povzetek' },
  { id: 'data-we-collect', label: 'Katere podatke zbiramo' },
  { id: 'how-we-use-data', label: 'Kako podatke uporabljamo' },
  { id: 'emails', label: 'E-pošta in obvestila' },
  { id: 'cookies', label: 'Piškotki in analitika' },
  { id: 'sharing', label: 'Procesorji in prenosi' },
  { id: 'retention', label: 'Hramba' },
  { id: 'rights', label: 'Vaše pravice' },
  { id: 'contact', label: 'Kontakt' },
]

export function PrivacyPolicyPage() {
  return (
    <StaticPage
      title="Politika zasebnosti"
      description="Kako Fukodrom obdeluje podatke pri ustvarjanju računa, prijavi, objavi lokacij, analitiki, moderiranju in morebitni prihodnji e-poštni komunikaciji."
      path="/privacy"
      eyebrow="Legal"
      updatedLabel="Zadnja vsebinska posodobitev: april 2026"
      sections={sections}
    >
      <section id="overview">
        <h2>Povzetek</h2>
        <p>
          Fukodrom je majhna skupnostna storitev za odkrivanje in deljenje piknik lokacij. Ta
          politika pojasnjuje, katere osebne podatke obdelujemo, zakaj jih potrebujemo in kako
          skušamo obdelavo ohraniti sorazmerno z dejanskim delovanjem produkta.
        </p>
        <p>
          Jedro storitve je preprosto: lahko brskate po zemljevidu, ustvarite račun z e-pošto in
          geslom, objavljate ali ocenjujete lokacije, uporabljate forumski del skupnosti in nam po
          potrebi pišete glede podpore ali uveljavljanja pravic. Ne prodajamo osebnih podatkov.
        </p>
      </section>

      <section id="data-we-collect">
        <h2>Katere podatke zbiramo</h2>
        <h3>1. Podatki o računu</h3>
        <p>
          Ko ustvarite račun, obdelujemo vsaj vaš e-poštni naslov, uporabniško ime in geslo v
          varno zaščiteni obliki. E-poštni naslov uporabljamo za identifikacijo računa, prijavo,
          komunikacijo o računu in za preprečevanje zlorab, kot so podvojeni ali avtomatizirani
          računi.
        </p>
        <h3>2. Podatki, ki jih ustvarite v storitvi</h3>
        <p>
          Če dodate lokacijo, napišete mnenje, uporabite funkcije shranjevanja ali oddate prijavo
          moderatorjem, obdelujemo vsebino, ki jo oddate, čas oddaje, povezani račun in osnovne
          tehnične metapodatke, potrebne za delovanje sistema, varnost ter reševanje sporov.
        </p>
        <h3>3. Podatki o uporabi in varnosti</h3>
        <p>
          Strežniki in aplikacija ustvarjajo omejene tehnične dnevnike, kot so IP naslov,
          request ID, podatki o seji, napravi ali brskalniku, piškotki za prijavo, CSRF zaščita in
          dogodki, povezani z varnostjo ali stabilnostjo. Ti podatki nam pomagajo odkrivati
          napake, omejevati zlorabe in vzdrževati storitev.
        </p>
        <h3>4. Forumski in skupnostni del</h3>
        <p>
          Če uporabite forumski del Fukodroma, se lahko del vaših podatkov obdela tudi v okviru
          te skupnostne infrastrukture, na primer za prijavo, prikaz uporabniškega profila,
          objave, zasebnost skupnosti in moderiranje pogovorov.
        </p>
      </section>

      <section id="how-we-use-data">
        <h2>Kako podatke uporabljamo in pravne podlage</h2>
        <p>
          Način obdelave je odvisen od namena. Kjer je to smiselno, se opiramo na več različnih
          pravnih podlag v smislu GDPR:
        </p>
        <ul>
          <li>
            <strong>Izvajanje pogodbe oziroma storitve:</strong> ustvarjanje in upravljanje računa,
            prijava, delovanje zemljevida, objava lokacij, shranjene lokacije, forumi in odziv na
            vaše zahteve znotraj storitve.
          </li>
          <li>
            <strong>Zakoniti interesi:</strong> varnost, preprečevanje goljufij, zaščita skupnosti,
            moderiranje, tehnična diagnostika, merjenje stabilnosti, omejeno izboljševanje produkta
            in obramba pravnih zahtevkov.
          </li>
          <li>
            <strong>Privolitev:</strong> analitični piškotki ali podobne tehnologije, kjer je to
            potrebno, ter morebitna prihodnja neposredna produktna ali skupnostna e-pošta, kadar za
            takšno pošiljanje potrebujemo predhodno soglasje.
          </li>
          <li>
            <strong>Zakonske obveznosti:</strong> kadar moramo podatke hraniti ali razkriti zaradi
            veljavne zakonodaje, sodne odredbe, regulatorne zahteve ali podobne obveznosti.
          </li>
        </ul>
        <p>
          Čeprav smo majhna storitev, skušamo zbrati le tisto, kar realno potrebujemo za delovanje
          računa, skupnosti in osnovno produktno analitiko. Ne gradimo oglaševalskih profilov in ne
          uporabljamo vaših podatkov za prodajo tretjim osebam.
        </p>
      </section>

      <section id="emails">
        <h2>E-pošta, prijava in prihodnja obvestila</h2>
        <h3>Transakcijska in storitvena e-pošta</h3>
        <p>
          Če uporabljate račun na Fukodromu, lahko vaš e-poštni naslov uporabimo za sporočila, ki so
          neposredno povezana z uporabo storitve. To lahko vključuje potrditev računa, varnostna
          opozorila, obvestila o pomembnih spremembah storitve, odzive na podporne zahteve ali drugo
          nujno komunikacijo, brez katere račun ne bi deloval razumno in varno.
        </p>
        <h3>Prihodnja produktna ali skupnostna e-pošta</h3>
        <p>
          V prihodnje lahko uporabnikom pošiljamo občasna e-sporočila o pomembnih novostih produkta,
          skupnostnih funkcijah, dogodkih ali podobnih temah, povezanih s Fukodromom. Tega ne bomo
          obravnavali kot samoumevno pravico. Kadar bo za takšno pošiljanje potrebna privolitev, jo
          bomo pridobili ločeno in jasno; kadar bo zakon dopuščal pošiljanje ob obstoječem odnosu z
          uporabnikom, bomo vedno zagotovili enostavno odjavo v vsakem sporočilu.
        </p>
        <p>
          Vaš e-poštni naslov ni javno objavljen zgolj zato, ker ustvarite račun. Vseeno pa lahko
          javno vidna vsebina, ki jo objavite sami, posredno prispeva k vaši prepoznavnosti znotraj
          skupnosti.
        </p>
      </section>

      <section id="cookies">
        <h2>Piškotki in analitika</h2>
        <p>
          Fukodrom uporablja nujne piškotke oziroma podobne lokalne mehanizme za prijavo,
          varnost seje, zaščito pred zlorabami in shranjevanje vaših nastavitev zasebnosti, kot je
          izbira glede analitičnih piškotkov.
        </p>
        <p>
          Če to dovolite, uporabljamo tudi first-party analitiko za razumevanje delovanja produkta —
          na primer ogledov strani, iskanja, uporabe onboarding korakov ali interakcij z lokacijami.
          Namen te analitike je izboljševanje uporabniške izkušnje in ne gradnja oglaševalskega
          profila. Nastavitev lahko pozneje spremenite tako, da izbrišete lokalno shranjeno izbiro
          ali uporabite prihodnji upravljalnik nastavitev, ko bo na voljo.
        </p>
        <p>
          Lahko uporabljamo tudi osnovne diagnostične in varnostne tehnologije, ki pomagajo pri
          preprečevanju zlorab, merjenju napak in zagotavljanju stabilnosti storitve.
        </p>
      </section>

      <section id="sharing">
        <h2>Tretji izvajalci, infrastruktura in mednarodni prenosi</h2>
        <p>
          Za delovanje Fukodroma lahko uporabljamo zunanje ponudnike infrastrukture in orodij, ki v
          našem imenu obdelujejo osebne podatke kot pogodbeni obdelovalci. To so lahko na primer:
        </p>
        <ul>
          <li>ponudniki gostovanja, strežniške infrastrukture, baz podatkov in CDN storitev,</li>
          <li>ponudniki e-poštne dostave za storitvena ali prihodnja dovoljena sporočila,</li>
          <li>orodja za spremljanje napak in stabilnosti, kot je Sentry,</li>
          <li>skupnostna infrastruktura, kot je forumska platforma Discourse, če uporabite forum.</li>
        </ul>
        <p>
          Podatke delimo le v obsegu, ki je razumno potreben za izvedbo storitve, varnost, podporo,
          moderiranje ali izpolnjevanje pravnih obveznosti. Če moramo podatke prenesti izven Evropskega
          gospodarskega prostora, skušamo uporabiti ustrezne zaščitne ukrepe, na primer standardne
          pogodbene klavzule ali ponudnike iz držav z ustrezno ravnjo varstva, kjer je to mogoče.
        </p>
        <p>
          Del vsebine, ki jo objavite sami, je po naravi lahko javno vidna drugim uporabnikom ali
          obiskovalcem. Zato vas prosimo, da v objave ne vključujete osebnih podatkov drugih oseb,
          zasebnih naslovov ali drugih občutljivih informacij, za katere nimate ustrezne podlage.
        </p>
      </section>

      <section id="retention">
        <h2>Kako dolgo podatke hranimo</h2>
        <p>
          Podatke o računu praviloma hranimo, dokler račun obstaja, razen če jih moramo hraniti dlje
          zaradi legitimnih razlogov, kot so varnost, obravnava sporov, preprečevanje ponavljajočih se
          zlorab ali pravne obveznosti. Varnostne dnevnike, diagnostične zapise in analitične dogodke
          hranimo omejen čas, odvisno od njihovega namena in občutljivosti.
        </p>
        <p>
          Če račun zaprete ali zahtevate izbris, bomo podatke izbrisali ali anonimizirali v razumnem
          roku, razen tam, kjer je hramba še vedno potrebna za zakonite namene. Nekatere javne objave
          ali moderacijske evidence lahko ostanejo shranjene dlje, če je to potrebno za zaščito
          integritete skupnosti ali izpolnjevanje pravnih obveznosti.
        </p>
      </section>

      <section id="rights">
        <h2>Vaše pravice</h2>
        <p>
          Odvisno od vaše jurisdikcije, zlasti če za vas velja GDPR, lahko zahtevate dostop do osebnih
          podatkov, popravek netočnih podatkov, izbris, omejitev obdelave, ugovor zoper določene vrste
          obdelave ter prenosljivost podatkov, kjer je to primerno. Če obdelava temelji na privolitvi,
          jo lahko kadar koli prekličete za naprej.
        </p>
        <p>
          Prav tako imate pravico vložiti pritožbo pri pristojnem nadzornem organu za varstvo osebnih
          podatkov. Vseeno cenimo, če nam pred tem omogočite, da zadevo poskusimo rešiti neposredno.
        </p>
      </section>

      <section id="contact">
        <h2>Kontakt in spremembe politike</h2>
        <p>
          Za vprašanja o zasebnosti, zahteve glede podatkov ali prijavo varnostnih pomislekov nam
          pišite na <a href="mailto:privacy@fukodrom.com">privacy@fukodrom.com</a>.
        </p>
        <p>
          To politiko lahko občasno posodobimo, če se spremeni storitev, zakonodaja ali način
          obdelave. Če bodo spremembe bistvene, jih bomo poskušali predstaviti razumno opazno — na
          primer v aplikaciji ali po e-pošti, kadar je to primerno.
        </p>
      </section>
    </StaticPage>
  )
}
